function isNullOrUndefined(value: unknown): value is undefined | null {
  return value === null || value === undefined;
}

function isEmptyArray(arr: unknown): boolean {
  return Array.isArray(arr) && arr.length === 0;
}

function isOnlySpaces(value: unknown) {
  return !String(value).trim().length;
}

// eslint-disable-next-line arrow-body-style
export default (val: unknown) => {
  return !(isNullOrUndefined(val) || isEmptyArray(val) || isOnlySpaces(val) || val === false);
};
